import { parseDecimal, parseDate } from "@syla/shared/types/helpers/parsing";
import { TransportType } from "@syla/shared/types/helpers/TransportType";
import { ValueAssetsRequestBody } from "@syla/shared/types/requests/ValueAssetsRequest";
import { ValueAssetsResponse } from "@syla/shared/types/responses/ValueAssetsResponse";
import axios from "axios";
import { throwSylaApiError } from "../errors/throwSylaApiError";

export async function valueAssets({
  valueDate,
  baseAsset,
  assets,
}: {
  valueDate?: Date;
  baseAsset: { _id: string };
  assets: { _id: string }[];
}): Promise<ValueAssetsResponse> {
  const body: ValueAssetsRequestBody = {
    baseAsset,
    assets,
    date: valueDate?.toISOString(),
  };

  let data: TransportType<ValueAssetsResponse>;
  try {
    const response = await axios.post<TransportType<ValueAssetsResponse>>(
      `/assets/value-assets`,
      body,
    );
    data = response.data;
  } catch (error) {
    throwSylaApiError(error);
  }

  // convert api returned Decimal string to Decimal
  return {
    ...data,
    valueDate: parseDate(data.valueDate),
    rates: data.rates.map(({ asset, rate }) => ({
      asset,
      rate: parseDecimal(rate),
    })),
  };
}
